import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetVerification = (id) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params: id,
                method: 'get',
                url: urls.GET_LIST_VERIFICATIONS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetVerificationAction(data.data));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetVerification as SetGetVerification
}